import { PRICING_FAQS } from "@alm/domain/marketing/faqs";
import {
  Ban,
  Building2,
  CalendarClock,
  Download,
  Layers,
  Unlock,
  type LucideIcon,
} from "@/lib/public-icons";

/* Terms stated on the page as commitments, above the plans. The figure stays off the page (the
 * operator's decision). Each is something an operator can hold us to and none is softened: "month
 * to month", "no setup fee". */
export interface Term {
  icon: LucideIcon;
  title: string;
  body: string;
}

export const terms: Term[] = [
  {
    icon: CalendarClock,
    title: "Month to month",
    body: "There is no annual contract to sign before you can start. You are committed for the month you are in, and that is the whole of it.",
  },
  {
    icon: Layers,
    title: "Add or drop any month",
    body: "Switch a module or an AI employee on the month you want it, and off the month you don't. Nothing waits for a renewal date twelve months out.",
  },
  {
    icon: Ban,
    title: "No setup or implementation fee",
    body: "Nothing is charged to get you running. No onboarding fee, no implementation fee, no charge for loading your records in.",
  },
  {
    icon: Building2,
    title: "No per-bed or per-seat math",
    body: "You are not billed by the bed, by the resident or by the login. Fill a room, hire a caregiver, give an administrator an account, the price does not move.",
  },
  {
    icon: Download,
    title: "Export at any time",
    body: "Residents, financials, reports and documents export to CSV, Excel and PDF from inside the product, whenever you want them. You do not have to ask us.",
  },
  {
    icon: Unlock,
    title: "No lock-in, no exit fee",
    body: "Leaving costs nothing and you take your records with you. Nothing is held back to make going harder than coming.",
  },
];

export const pricingFaqs = PRICING_FAQS;
